import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";
import Wrapper from "../../../../Components/Wrapper/Wrapper";
import theme from "../../../../Consts/Theme";
import ButtonBasic from "../../../../Components/ButtonBasic/ButtonBasic";

import hero2026 from "./Static/hero2026.png";
import HeroCardNumbers from "./HeroCardNumbers";
import HeroCardMaxStudents from "./HeroCardMaxStudents";

// styled-components
const StyledContainer = styled.section`
  background-color: #000;
  width: 100%;
  position: relative;
  z-index: 0;
  overflow: hidden;
  padding-top: 110px;
  padding-bottom: 120px;
  min-height: 100vh;

  .hero-image {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url(${hero2026});
    background-size: cover;
    background-position: center right;
    background-repeat: no-repeat;
    z-index: 0;
  }
`;

const StyledHeroContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  max-width: 620px;
  padding-top: 40px;

  h1 {
    color: #fff;
    font-family: Raleway;
    font-size: 80px;
    font-style: normal;
    font-weight: 800;
    line-height: 88px;
    letter-spacing: -1px;
    margin: 0;
    text-transform: uppercase;
  }

  p.subheading {
    color: #fff;
    font-family: Raleway;
    font-size: 26px;
    font-style: normal;
    font-weight: 500;
    line-height: 34px;
    margin: 32px 0 0 0;
  }

  .cta-wrap {
    margin-top: 40px;
    align-self: flex-start;

    button {
      padding: 16px 28px;
    }
  }

  @media (max-width: 1200px) {
    max-width: 540px;

    h1 {
      font-size: 64px;
      line-height: 72px;
    }

    p.subheading {
      font-size: 22px;
      line-height: 30px;
    }
  }
`;

const StyledStatisticsContainer = styled.div`
  display: flex;
  align-items: stretch;
  margin-top: 56px;
  gap: 8px;

  /* Override the nested card's left-margin so the two cards sit flush next to
     each other with our own gap instead */
  .max-students-container {
    margin-left: 0;
  }
`;

const HomepageHeroDesktop = ({ handleScrollToSection, landingNumbers }) => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <div className="hero-image" aria-hidden="true" />
      <Wrapper>
        <header>
          <StyledHeroContent>
            <h1>
              Приемниот
              <br />
              тест е отворен
            </h1>
            <p className="subheading">
              Студирај БЕСПЛАТНО!
              <br />
              Brainster Next - практичен IT факултет!
            </p>
            <div className="cta-wrap">
              <ButtonBasic
                variation="large"
                filling={"altBlue"}
                text={t("homepage.hero_section.cta")}
                onClick={handleScrollToSection}
              />
            </div>
            <StyledStatisticsContainer>
              <HeroCardNumbers
                numbers={landingNumbers ?? 13}
                content={t(
                  "homepage.hero_section.hero_card_mobile.test_takers"
                )}
                bgColor={theme.lightDark}
              />
              <HeroCardMaxStudents />
            </StyledStatisticsContainer>
          </StyledHeroContent>
        </header>
      </Wrapper>
    </StyledContainer>
  );
};

export default HomepageHeroDesktop;
